module.exports = __webpack_public_path__ + "assets/img/guide-icon-copy.bba6dbb5.svg";